import React, { useState, useEffect } from 'react';
import R from 'ramda';

import { useDispatch, useSelector } from 'react-redux';

import { Dropdown } from 'react-bulma-companion';

export default function Checkbox({ id, updateValue, required, label, autoFocus, placeholder, name, options, classes, defaultValue = [] }) {
    const { answers } = useSelector(R.pick(['answers']));

    const [values, setValues] = useState(defaultValue);

    useEffect(() => {
        if (answers?.find(q => q.qID == id)) {
            setValues(answers.find(q => q.qID == id).answer);
        }
    }, [])

    useEffect(() => {
        if (answers?.find(q => q.qID == id)) {
            setValues(answers.find(q => q.qID == id).answer);
        }
    }, [answers])

    const onChange = e => {
        const {value, checked} = e.target;

        let newValues = [];

        if (checked) {
            newValues = [...values, value];
        } else {
            newValues = values.filter(item => item !== value);
        }

        setValues(newValues);
        updateValue(id, newValues);
    }

    return (
        <div className={`checkbox-group ${classes.join(" ")}`}>
            {options.map((option, index) => (
                <div className="checkbox-option" key={option}>
                    <input type="checkbox" onChange={onChange} id={option} name={id} value={option} checked={values.includes(option)}/>
                    <label htmlFor={option}>{option}</label>
                </div>
            ))}
        </div>
    )
}